import { render, staticRenderFns } from "./BackdoorHome.vue?vue&type=template&id=3a83e870&scoped=true"
import script from "./BackdoorHome.vue?vue&type=script&lang=js"
export * from "./BackdoorHome.vue?vue&type=script&lang=js"
import style0 from "./BackdoorHome.vue?vue&type=style&index=0&id=3a83e870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83e870",
  null
  
)

export default component.exports